<template>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.7">
            <path d="M6 1C3.23242 1 1 3.23242 1 6C1 8.76758 3.23242 11 6 11C8.76758 11 11 8.76758 11 6C11 3.23242 8.76758 1 6 1ZM6 2C8.23242 2 10 3.76758 10 6C10 8.23242 8.23242 10 6 10C3.76758 10 2 8.23242 2 6C2 3.76758 3.76758 2 6 2ZM5.5 3.5V6.20312L5.64062 6.35938L7.14062 7.85938L7.85938 7.14062L6.5 5.78125V3.5H5.5Z" fill="white"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "clocks"
    }
</script>

<style scoped>

</style>